import { useCallback, useState } from 'react';
import {
  HeadingText,
  Box,
  Button,
  ParagraphText,
  FormField,
  GDSInputStatus,
  StackLayout,
  StackItem,
  Select,
} from '@leagueplatform/genesis-core';
import { AppTenant } from 'types/app';

type TenantIdFormProps = {
  onValidSubmit: (tenantId: string) => void;
};

const options = [
  { key: '', value: '', label: 'Please choose a tenant' },
  { key: '1', value: AppTenant.HighmarkIel, label: 'Highmark IEL' },
  {
    key: '2',
    value: AppTenant.ReferenceTenant,
    label: 'League Reference Tenant',
  },
  {
    key: '3',
    value: AppTenant.HighmarkBeneficity,
    label: 'Highmark Beneficity',
  },
  {
    key: '4',
    value: AppTenant.HighmarkAllMyHealth,
    label: 'Highmark All My Health',
  },
];

export const TenantIdForm = ({ onValidSubmit }: TenantIdFormProps) => {
  const [inputValue, setInputValue] = useState<string>('');
  const [validation, setValidation] = useState<{
    inputStatus: GDSInputStatus;
    statusMessage: string;
  }>();

  const submitTenant = useCallback(
    (event: React.FormEvent<HTMLFormElement>) => {
      event.preventDefault();

      if (inputValue === '') {
        setValidation({
          inputStatus: 'error',
          statusMessage: 'Sign in to your customer support experience.',
        });
      } else {
        onValidSubmit(inputValue);
      }
    },
    [inputValue, onValidSubmit],
  );

  return (
    <StackLayout
      orientation="horizontal"
      verticalAlignment="stretch"
      css={{
        height: '100vh',
      }}
    >
      <Box
        css={{ backgroundColor: '$surfaceBackgroundSecondary', width: '60%' }}
      />
      <StackItem
        verticalAlignment="center"
        horizontalAlignment="center"
        css={{
          width: '100%',
        }}
      >
        <HeadingText
          size="xxl"
          level="1"
          css={{ marginBottom: '$one', textAlign: 'center' }}
        >
          Sign in to your customer support experience!
        </HeadingText>
        <ParagraphText css={{ paddingBottom: '$two' }}>
          Select your tenant!
        </ParagraphText>
        <Box as="form" css={{ width: '400px' }} onSubmit={submitTenant}>
          <FormField
            css={{ width: 'auto' }}
            id="tenant-id-input"
            label="Enter tenant id"
            name="Enter tenant id"
            inputStatus={validation?.inputStatus}
            statusMessage={validation?.statusMessage}
            hideLabel
            required
          >
            <Select
              options={options}
              id="tenantIdInput"
              aria-label="Select your tenant"
              css={{ width: '350px' }}
              onChange={(e) => {
                setInputValue(e.currentTarget.value);
                setValidation(undefined);
              }}
            />
          </FormField>
          <Button
            type="submit"
            width="fillContainer"
            css={{
              marginTop: '$oneAndHalf',
              borderRadius: '$radii$medium $radii$medium',
            }}
          >
            Sign in
          </Button>
        </Box>
      </StackItem>
    </StackLayout>
  );
};
